import React from 'react';
import './App.css';
import Game from "./game/Game";
import {CookiesProvider} from "react-cookie";
import {GameContext} from './content/GameContext';
import {Container, createTheme, ThemeOptions, ThemeProvider} from '@mui/material';

interface AppProps<T> {
    context: GameContext<T>;
}

function App<T>(props: AppProps<T>) {
    const themeOptions: ThemeOptions = {
        palette: {
            primary: {
                main: props.context.getPrimaryColor(),
            },
            secondary: {
                main: props.context.getSecondaryColor(),
            },
            background: {
                default: "#f5f2ec"
            },
            text: {
                primary: '#000000',
                secondary: props.context.getPrimaryColor()
            },
        },
    };

    return (
        <CookiesProvider>
            <ThemeProvider theme={createTheme(themeOptions)}>
                <Container sx={{width: "100%", height: "100vh", justifyContent: "center"}}
                           maxWidth={false}
                           disableGutters >
                    <Game context={props.context} startTime={new Date()}/>
                </Container>
            </ThemeProvider>
        </CookiesProvider>
    );
}

export default App;
